import axios from './axios';
import { LoginForm, RegisterForm, AuthResponse, AuthUserRegResponse, AuthUserResponse, FeedbackParam } from '../types/user';

export const login = async (data: LoginForm): Promise<AuthResponse> => {
  const response = await axios.post('/api3/app/account/emailLogin', data);
  return response.data.data;
};

export const register = async (data: RegisterForm): Promise<AuthUserRegResponse> => {
  const response = await axios.post('/api3/app/account/emailRegister', data);
  return response.data;
};

export const logout = async (): Promise<void> => {
  const response = await axios.post('/api3/app/account/logout');
  localStorage.removeItem('token');
  return response.data.data;
};

export const getCurrentUser = async (): Promise<AuthUserResponse> => {
  const response = await axios.get('/api3/app/user/getUserInfo');
  // const response = await axios.get('/api3/app/account/getUserInfo');
  return response.data.data;
}; 

export const feedback = async (data: FeedbackParam): Promise<AuthUserResponse> => {
  const response = await axios.post('/api3/app/feedback/submit', data);
  return response.data.data;
}; 

export const forgotPassword = async (data: { email: string, code: string, password: string }): Promise<{code: number, message: string}> => {
  const response = await axios.post('/api3/app/account/forgotPassword', data);
  return response.data;
}; 

export const sendEmailCode = async (data: {email: string}): Promise<AuthUserResponse> => {
  const response = await axios.post('/api3/app/account/sendEmailCode', data);
  return response.data.data;
}; 
